module.exports = __webpack_public_path__ + "static/media/WeWork-logo-White.a7524bad.svg";